import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import * as React from "react";
import { mediaCSS, ZERO_BREAKPOINT, NextSectionButton } from "@redocly/reference-docs";
import styled from "../../../styled-components";
import { Menu } from "../../Menu/Menu";
import { NavButtonsWrapper } from "../../styled/";
import { Flex, Link } from "@redocly/developer-portal/ui";
import { NextPageWrapperWithRightPanel } from "../../../components/styled";
export default function SidebarLayout(a) {
  var b = a.items,
      c = a.location,
      d = a.prevPage,
      e = a.nextPage,
      f = a.withRightPanel,
      g = a.isReferenceDocs,
      h = a.withToc,
      i = a.children,
      j = a.context,
      k = a.apiVersionId,
      l = a.apiVersions,
      m = a.pageId,
      n = g ? NextPageWrapperWithRightPanel : NextPageWrapper;
  return /*#__PURE__*/React.createElement(FlexWrapper, {
    position: "relative",
    flex: "1 0 auto"
  }, /*#__PURE__*/React.createElement(Menu, {
    items: b,
    location: c,
    context: j || {},
    apiVersionId: k,
    apiVersions: l,
    pageId: m
  }), /*#__PURE__*/React.createElement(Flex, {
    width: {
      xs: "100%",
      medium: 0
    },
    flex: "1 1 auto",
    flexDirection: "column"
  }, i, (e || d) && /*#__PURE__*/React.createElement(PageWrapper, null, /*#__PURE__*/React.createElement(n, {
    withToc: h,
    withRightPanel: f
  }, d && /*#__PURE__*/React.createElement(LinkBack, {
    "data-cy": "back-to",
    to: d.link
  }, /*#__PURE__*/React.createElement(NextSectionButton, null, "Back to ", /*#__PURE__*/React.createElement("strong", null, d.label))), e && /*#__PURE__*/React.createElement(LinkForward, {
    "data-cy": "next-to",
    to: e.link
  }, /*#__PURE__*/React.createElement(NextSectionButton, null, "Next to ", /*#__PURE__*/React.createElement("strong", null, e.label)))), h && /*#__PURE__*/React.createElement(TableOfContentStub, null))));
}
var FlexWrapper = styled(Flex)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var _flexDirection;

  var a = _ref.theme;
  return mediaCSS({
    flexDirection: (_flexDirection = {}, _flexDirection[ZERO_BREAKPOINT] = "column", _flexDirection[a.sidebar.showAtBreakpoint] = "row", _flexDirection)
  });
});
export var PageWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  width: 100%;\n"])));
var NextPageWrapper = styled(NavButtonsWrapper)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  padding-left: 0;\n  padding-right: 0;\n\n  @media only screen and (min-width: ", ") {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n"])), function (_ref2) {
  var a = _ref2.theme;
  return a.breakpoints.medium;
}),
    TableOfContentStub = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  display: none !important;\n  @media only screen and (min-width: ", ") {\n    width: ", ";\n    display: block !important;\n  }\n"])), function (_ref3) {
  var a = _ref3.theme;
  return a.breakpoints.medium;
}, function (_ref4) {
  var a = _ref4.theme;
  return a.tocPanel.width;
}),
    PaginationLink = styled(Link)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 0.5em;\n\n  & + & {\n    margin-left: auto;\n  }\n\n  @media only screen and (max-width: ", ") {\n    margin-left: auto;\n  }\n\n  @media print {\n    display: none;\n  }\n"])), function (_ref5) {
  var a = _ref5.theme;
  return a.breakpoints.small;
}),
    LinkBack = styled(PaginationLink)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  &:only-child {\n    margin-left: 0;\n    margin-right: auto;\n  }\n"]))),
    LinkForward = styled(PaginationLink)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  margin-left: auto;\n"])));